import { type ReactNode } from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "shared/components";
import { SubdivisionTimelineItemHeading } from "./SubdivisionTimelineItemHeading";

export interface SubdivisionTimelineItemProps {
  children: ReactNode;
  cost?: string | undefined | null;
  id: string;
  onOpenChange: (id: string) => void;
  selectedId: string;
  timeframe: string;
  title: string;
}

export function SubdivisionTimelineItem({
  children,
  cost,
  id,
  onOpenChange,
  selectedId,
  timeframe,
  title,
}: SubdivisionTimelineItemProps) {
  const isOpen = selectedId === id;

  return (
    <Accordion
      collapsible
      onValueChange={onOpenChange}
      type="single"
      value={selectedId}
    >
      <AccordionItem value={id}>
        <AccordionTrigger className="text-textLink items-start py-0 text-left hover:no-underline [&>svg]:hidden">
          <SubdivisionTimelineItemHeading
            cost={cost}
            isOpen={isOpen}
            timeframe={timeframe}
            title={title}
          />
        </AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
